import { render } from "./EditReceiver.vue?vue&type=template&id=1e776046&scoped=true"
import script from "./EditReceiver.vue?vue&type=script&lang=js"
export * from "./EditReceiver.vue?vue&type=script&lang=js"

import "./EditReceiver.vue?vue&type=style&index=0&id=1e776046&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e776046"]])

export default __exports__